import {setCookie, getCookie} from '../helpers/cookie-scripts.js';

export default () => {

    let cookieDaysLifeTime = 45;
    let cookiePopup = document.querySelector('.cookie-popup');
    let acceptBtn = document.querySelector('.cookie-popup__btn--accept');

    if (cookiePopup) {
        let cookieVal = getCookie('cookiesPolicy');

        if (cookieVal !== 'accepted') {
            cookiePopup.classList.remove('_click-active');

        }
        if (acceptBtn) {
            acceptBtn.addEventListener('click', function () {
                setCookie('cookiesPolicy', 'accepted', cookieDaysLifeTime);
                cookiePopup.classList.add('_click-active');
            });
        }
    }

}